<template>
  <div style="position: relative">
    <div class="iconfont icon-fangda" @click="show_chart_dialog = !show_chart_dialog"></div>
    <div
      style="width: 100%; height: 420px; margin-top: 10px"
      ref="chart"
      id="c_54241701"
      v-loading="loading"
      element-loading-text="数据量巨大，正在计算中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"></div>
    <div style="margin-top: 30px">
      <el-table
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"
        class="table1"
        :header-cell-style="tableStyle"
        :data="chart_data"
        style="width: 100%">
        <el-table-column prop="index" label="代码" min-width="94"> </el-table-column>
        <el-table-column
          :formatter="formatterColumn"
          :prop="k"
          :label="k"
          min-width="94"
          sortable
          align="right"
          v-for="k in tabKeys"
          :key="k">
          <template slot-scope="scope">
            {{
              scope.row[k]
                ? relative === 3 || relative === 2
                  ? numberFix2((scope.row[k] || 0)) + '亿'
                  : number2Pct(scope.row[k] || 0)
                : ''
            }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_options" />
  </div>
</template>

<script>
import { debounce, number2Pct, numberFix2 } from '@/utils';
import { fnReturnTableStyle } from '@/utils/util';
import ChartDialog from '../../Basic/ChartDialog.vue';

export default {
  props: {
    chart_data: Array,
    loading: Boolean,
    relative: Number,
  },
  components: {
    ChartDialog,
  },
  data() {
    return {
      ROOTFONTFIZE: '',
      chart_options: {},
      show_chart_dialog: false,
    };
  },
  watch: {
    currentTheme() {
      this.fnGetTheme();
      this.debounceRender();
    },
    chart_data() {
      this.debounceRender();
    },
  },
  computed: {
    tabKeys() {
      if (this.chart_data.length === 0) return [];
      return Object.keys(this.chart_data[0]).filter((n) => n !== 'index');
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
  },
  methods: {
    number2Pct,
    numberFix2,
    formatterColumn(row, column, cellValue, index) {
      return number2Pct(cellValue);
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    debounceRender: debounce(function () {
      this.chartRender();
    }, 400),
    chartRender() {
      if (!this.chart_data.length) {
        this.echart_instance && this.echart_instance.clear();
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      const data = this.chart_data;
      const xLabel = Object.keys(data[0]).filter((k) => k !== 'index');

      const color_map = {
        券商资管: '#96dcf8',
        '银行/银行理财子': '#4ea72e',
        公募基金及基金子公司: '#46b1e1',
        不良资产管理: '#095f80',
        国资投资公司: '#0d3a4e',
        其他类型: '#46b1e1',
        产业资本: '#aeaeae',
        私募基金: '#9492ee',
        信托: '#1f8ec0',
        保险: '#0f9ed5',
        券商自营: '#0b76a0',
        原始权益人或关联方: '#5e5ce6',
        个人: '#5ae8ed',
        /* 券商资管: '#9492ee',
        '银行/银行理财子': '#aeaeae',
        公募基金及基金子公司: '#095f80',
        不良资产管理: '#46b1e1',
        国资投资公司: '#96dcf8',
        其他类型: '#0d3a4e',
        产业资本: '#4ea72e',
        私募基金: '#0b76a0',
        信托: '#0f9ed5',
        保险: '#46b1e1',
        券商自营: '#5e5ce6',
        原始权益人或关联方: '#5ae8ed', */
      };

      const series = data.map((item) => {
        const { index, ...args } = item;
        return {
          name: index,
          data: Object.values(args),
          type: 'bar',
          stack: 'stack',
          itemStyle: {
            color: color_map[item.index],
          },
          // barWidth: 70,
        };
      });

      const options = {
        series,
        xAxis: {
          type: 'category',
          data: xLabel,
          axisLabel: {
            interval: 0,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: (value) => {
              if (this.relative === 3 || this.relative === 2) {
                return value;
              }
              return numberFix2(value * 100) + '%';
            },
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            color: OPTIONDATA.yAxis.axisLabel.color,
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
          max: (value) => {
            if (this.relative === 1) {
              return 1;
            }
            return null;
          },
        },
        legend: {
          itemWidth: 10,
          itemHeight: 10,
          right: 0,
          top: 'center',
          orient: 'vertical',
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (12 / 144),
          },
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const p = params[0].name;
            return (
              p +
              ' <br />' +
              params
                .map(({ marker, seriesName, value }) => {
                  const k = seriesName;
                  const v =
                  this.relative === 3 || this.relative === 2
                    ? numberFix2(value) + '亿'
                    : number2Pct(value);

                  return marker + k + `<span style="margin-left:10px">${v}</span>`;
                })
                .join('<br />')
            );
          },
        },
        toolbox: {
          // 工具箱按钮
          right: 30,
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        grid: {
          top: this.ROOTFONTFIZE * (30 / 144),
          left: this.ROOTFONTFIZE * (20 / 144),
          right: this.ROOTFONTFIZE * (140 / 144),
          bottom: this.ROOTFONTFIZE * (20 / 144),
          containLabel: true,
        },
      };

      this.echart_instance.setOption(options);
      this.echart_instance.resize();
      this.chart_options = Object.freeze(options);
    },
  },
  mounted() {
    this.debounceRender();
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
    this.echart_instance && this.echart_instance.dispose();
  },
};
</script>

<style lang="less" scoped>
.icon-fangda {
  position: absolute;
  right: 8px;
  top: 4px;
}

//fix 滚动条重叠部分背景颜色
/deep/.el-table__body-wrapper::-webkit-scrollbar-corner {
  background-color: transparent;
}
/deep/.items-center {
  align-items: center;
}
/deep/.relative {
  position: relative;
}
/deep/.flex {
  display: flex;
}

/* el-table start */

::v-deep .table1 table {
  border: none;
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* el-table end */
</style>
